<script setup>
import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";
import UtilArray from "@/utils/UtilArray.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "visualizandoDadoContaAReceberAvulsa",
    "dadoOriginal"
]);

const emits = defineEmits([
    "update:alteraVisualizandoDadoContaAReceberAvulsa",
]);

//==================================================================//
//============================== Dado ==============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//======= Altera Visualizando Dado Conta a Receber Avulsa ==========//
//==================================================================//

const alteraVisualizandoDadoContaAReceberAvulsa = (update) =>{

    emits('update:alteraVisualizandoDadoContaAReceberAvulsa',update);

};

//==================================================================//
//========================== Altera Dado ===========================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update);

};

//==================================================================//
//==================== Altera Recebimentos =========================//
//==================================================================//

const alteraRecebimento = (update)=>{

    let recebimentos = dado?.value?.recebimentos?.map((recebimento)=>{

        if(recebimento.id != update.id){
            return recebimento;
        }

        return UtilObject.merge(recebimento,update);

    });

    alteraDado({
        recebimentos: recebimentos
    });

};

//==================================================================//
//========================= Prepara Dado ===========================//
//==================================================================//

const preparaDado = (dado = {})=>{

    let recebimentos = dado?.recebimentos?.map((recebimento)=>{

        let vinculos = recebimento?.vinculos?.map((vinculo)=>{
            
            return{
                id: vinculo?.recebimento?.id || "",
                sequencia: vinculo?.recebimento?.sequencia || "",
                tipo: vinculo?.recebimento?.tipo || "",
                status: vinculo?.recebimento?.status || "",
                contaAReceberCodigo: vinculo?.contaAReceber?.codigo || "",
                dataCriacao: vinculo?.recebimento?.dataCriacaoFormatada || "",
                dataVencimento: vinculo?.recebimento?.dataVencimentoFormatada || "",
                valorRecebimento: vinculo?.recebimento?.valorRecebimento || "",
            }

        });

        let notaFiscalEmitida = recebimento?.vinculos[0]?.notaFiscalEmitida || {};

        let recebimentoStatus = recebimento?.status?.replace("Recebimento", "Vinculo");

        return {
            id: recebimento?.id || "", 
            aberto: false,
            sequencia: recebimento?.sequencia || "",
            tipo: recebimento?.tipo || "",
            status: recebimentoStatus || "",
            notaFiscalEmitidaNumero: notaFiscalEmitida?.numero || "",
            notaFiscalEmitidaChaveAcesso: notaFiscalEmitida?.chaveAcesso || "",
            notaFiscalEmitidaPlugNotasID: notaFiscalEmitida.plugNotasID || "",
            dataCriacao: recebimento?.dataCriacaoFormatada || "",
            dataVencimento: recebimento?.dataVencimentoFormatada || "",
            valorRecebimento: recebimento?.valorRecebimento || "",
            vinculos: vinculos || [],
        };

    });

    dado = {
        id: dado?.id || "",
        origem: dado?.origem || "",
        numero: dado?.numero || "",
        clienteNome: dado?.cliente?.nome || "",
        jobCodigo: dado?.job?.codigo|| "",
        jobParcelaCodigo: dado?.jobParcela?.codigo|| "",
        jobParcelaSequencia: dado?.jobParcela?.sequencia|| "",
        jobParcelaTipo: dado?.jobParcela?.tipo|| "",
        jobParcelaDescricao: dado?.jobParcela?.descricao|| "",
        jobParcelaFormatado: "",
        contaFinanceiraNome: dado?.contaFinanceira?.nome|| "",
        valorOriginal: dado?.valorOriginal|| 0,
        valorRecebido: dado?.valorRecebido|| 0,
        valorParaReceber: dado?.valorParaReceber|| 0,
        dataCriacao: dado?.dataCriacaoFormatada || "",
        dataVencimento: dado?.dataVencimentoFormatada || "",
        recebimentos: recebimentos || []
    }

    dado.jobParcelaFormatado = `${dado?.jobParcelaCodigo} - ${dado?.jobParcelaSequencia} - ${dado?.jobParcelaTipo}`;

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//==================================================================//
//=========== Watch => visualizandoDadoContaAReceberAvulsa =========//
//==================================================================//

watch(()=> props.visualizandoDadoContaAReceberAvulsa, () => {

    if(props.visualizandoDadoContaAReceberAvulsa == true){
        preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.visualizandoDadoContaAReceberAvulsa"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="props.dado"
                    @update:alteraVisualizandoDadoContaAReceberAvulsa="alteraVisualizandoDadoContaAReceberAvulsa"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="dado"
                    @update:alteraRecebimento="alteraRecebimento"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

